import * as types from '../mutation-types'

export default {
	namespaced: true,

	state: {
		keywords: []
	},

	actions: {
		fetchAll ({ commit }) {
			return window.axios.get('/keywords').then(({ data }) => {
				commit(types.STORE_KEYWORDS, data)
				return data
			})
		}
	},

	mutations: {
		[types.STORE_KEYWORDS] (state, keywords) {
			state.keywords = keywords
		}
	}
}
